'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var DELETE = exports.DELETE = 'DELETE';
var GET = exports.GET = 'GET';
var HEAD = exports.HEAD = 'HEAD';
var POST = exports.POST = 'POST';
var PUT = exports.PUT = 'PUT';
var PATCH = exports.PATCH = 'PATCH';


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-query/dist/commonjs/constants/http-methods.js
// module id = 326
// module chunks = 27